import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

/** Breed input with autocomplete pulled from previously entered breeds for that species. */
export default function BreedAutocomplete({ species, value, onChange, testId = "breed-input" }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const h = setTimeout(async () => {
      try {
        const params = {};
        if (species) params.species = species;
        if (value) params.q = value;
        const { data } = await api.get("/breeds", { params });
        setItems(data);
      } catch {
        setItems([]);
      }
    }, 150);
    return () => clearTimeout(h);
  }, [species, value]);

  useEffect(() => {
    function onClickOutside(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const filtered = items.filter(
    (it) => !value || it.breed.toLowerCase() !== value.trim().toLowerCase()
  );

  return (
    <div ref={wrapRef} className="relative" data-testid={testId}>
      <input
        className="pf-input"
        value={value || ""}
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        placeholder=""
      />
      {open && filtered.length > 0 && (
        <div className="absolute z-30 mt-1 left-0 right-0 bg-white border border-pf-border rounded-lg shadow-card max-h-56 overflow-auto">
          {filtered.slice(0, 8).map((it, i) => (
            <button
              key={i}
              type="button"
              onClick={() => {
                onChange(it.breed);
                setOpen(false);
              }}
              className="w-full text-left px-3 py-1.5 text-sm hover:bg-pf-bg flex justify-between items-center"
              data-testid={`breed-suggest-${i}`}
            >
              <span>{it.breed}</span>
              <span className="text-[10px] text-pf-text-secondary">{it.count}×</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
